var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-4"},[_c('v-card-title',{staticClass:"text-h5"},[_vm._v("Expressions")]),_c('expression-selector')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }